import React from 'react';
import { Link } from 'react-router-dom';
import isExternalUrl from 'commons/isExternalUrl';
import PropTypes from 'prop-types';

const SubLink = ({ name, url }) => (
  <li key={url}>
    {isExternalUrl(url) ? (
      <a
        href={url}
        className="font-normal text-base leading-[25px] text-[#888] border-0 no-underline hover:text-[#484848] hover:transition-[opacity_.3s,transform_.3s] hover:![border-bottom:1px_solid_#484848]"
      >
        {name}
      </a>
    ) : (
      <Link
        to={url}
        className="font-normal text-base leading-[25px] text-[#888] border-0 no-underline hover:text-[#484848] hover:transition-[opacity_.3s,transform_.3s] hover:![border-bottom:1px_solid_#484848]"
      >
        {name}
      </Link>
    )}
  </li>
);

SubLink.propTypes = {
  name: PropTypes.string,
  url: PropTypes.string,
};

export default SubLink;
